<script>
  export let data;
  import { store } from '$client';

  const { city } = store;
  const placeholder = 'https://admin.uberi.pro/uploads/review_photo_8d44aad77c.svg';
  $: review = data.attributes;
</script>

<li itemprop="review" itemscope itemtype="http://schema.org/Review">
  <meta itemprop="name" value="Отзыв нашего клиента" />
  <div>
    <img
      loading="lazy"
      itemprop="image"
      height="80"
      width="80"
      src={review.img?.data?.attributes?.url ?? placeholder}
      alt="Наши клиенты" />
    <div>
      <h3 itemprop="author">{review.name}</h3>
      <div itemprop="itemReviewed" itemscope itemtype="https://schema.org/ProfessionalService">
        <meta itemprop="name" content="Вывоз ненужных вещей в г. {$city.header}" />
        <meta itemprop="image" content="/favicon.svg" />
        <meta itemprop="telephone" content={$city.phone} />
        <meta itemprop="address" content={$city.office} />
      </div>
      <span class="stars" itemprop="reviewRating" itemscope itemtype="http://schema.org/Rating">
        <meta itemprop="worstRating" content="0" />
        <meta itemprop="bestRating" content="5" />
        <meta itemprop="ratingValue" content={review.rating} />
        {#each new Array(5).fill() as _, i}
          <span data-selected={review.rating > i} />
        {/each}
      </span>
    </div>
  </div>

  <blockquote itemprop="reviewBody">{review.review}</blockquote>
</li>

<style lang="scss">
  li > div {
    display: inline-flex;
    align-items: center;

    > div {
      display: flex;
      flex-direction: column;
      gap: 12px;
      margin-left: 20px;

      h3 {
        font-weight: bold;
        font-size: 16px;
        font-family: Vela Sans;
      }
    }
  }

  li {
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding: 24px;
    background: #fff;
    border-radius: 15px;
    box-shadow: 0 1px 15px 0 #000f5c0d;

    blockquote {
      display: -webkit-box;
      overflow: hidden;
      color: #2c333c;
      font-size: 16px;
      font-family: Roboto;
      white-space: pre-wrap;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 5; /* start showing ellipsis when 3rd line is reached */
    }
  }

  .stars {
    display: inline-flex;
    gap: 12px;

    span {
      width: 24px;
      height: 24px;
      background-position: center center;
      background-size: contain;
      cursor: pointer;
    }

    span[data-selected='true'] {
      background-image: url('https://admin.uberi.pro/uploads/star_7137f7de2b.svg');
    }

    span[data-selected='false'] {
      background-image: url('https://admin.uberi.pro/uploads/star_3e7a6d378e.svg');
    }
  }
</style>
